import React from "react";
// import perfectOrderRateImg from "./perfectOrderRate.png";
// import warehouseOperatingCostDistImg from "./warehouseOperatingCostDist.png";
import NavBar from "../NavBar";
import LogisticsCardRender from "./LogisticsCardRender";
import './LogisticsDashboard.css'
import {LogisticsCardUpData,LogisticsCardDnData} from './LogisticsCardData'
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SalesBreakdown from "../SalesBreakdown";
import SingleLineChart from "../SingleLineChart";
import { LogisticsLineData } from "../SingleLineChartData";
import LogisticsPieChart from "./Components/LogisticsPieChart";
import DotsComponent from '../DotsComponent'
import GraphLabel1 from "../Components/GraphLabel1";

export default function LogisticsDashboard() {
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Logistics</span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Dashboard</h2>
        <div id="Right-content-Down-Filters">
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="right-content-cards">
        <LogisticsCardRender comp={LogisticsCardUpData} />
      </div>
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">PERFECT ORDER RATE</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel1 color = {"#394A7E"} value={'Sales per month'}/>
          <SingleLineChart data={LogisticsLineData}/>
        </div>
        <div className="dashboard-graph">
          <DotsComponent />
          <LogisticsPieChart/>
        </div>
      </div>
      <div id="right-content-cards">
        <LogisticsCardRender comp={LogisticsCardDnData} />
      </div>
    </>
  );
}
